import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const transformations = ['Preparar menús semanales prácticos que te ahorran tiempo.', 'Tener recetas paso a paso que cualquiera puede seguir.', 'Organizar tandas desde casa y conservar correctamente las viandas.', 'Empezar a ofrecer viandas a familia, vecinos o clientes iniciales con seguridad.'];
export const TransformationSection: React.FC = () => {
  return <section className="py-24 px-4 md:px-8 bg-gradient-to-b from-brand-cream to-white relative overflow-hidden" data-id="element-156">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-brand-light rounded-full mix-blend-multiply filter blur-3xl opacity-30 -translate-x-1/2 -translate-y-1/2" data-id="element-157"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-brand-soft rounded-full mix-blend-multiply filter blur-3xl opacity-20 translate-x-1/3 translate-y-1/3" data-id="element-158"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-160">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-primary mb-6" data-id="element-161">
            Lo que vas a lograr con COCINA VIANDERA
          </h2>
          <p className="text-xl text-brand-text-medium" data-id="element-162">
            Transformá el caos de la cocina en un sistema simple y rentable.
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-163">
          {transformations.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex items-center space-x-6 bg-white p-6 rounded-2xl shadow-md border border-brand-cream/50" data-id="element-164">
              <div className="flex-shrink-0" data-id="element-165">
                <CheckCircle2 className="w-8 h-8 text-brand-soft" data-id="element-166" />
              </div>
              <p className="text-lg md:text-xl text-brand-text-dark font-medium" data-id="element-167">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};